<template>
  <div class="content-panel">
    <slot />
  </div>
</template>

<script setup></script>

<style scoped>
.content-panel {
  background-color: var(--fh-color-bg-input-default);
  border-radius: 16px;
  box-sizing: border-box;
  width: 640px;
  margin-bottom: var(--fh-size-sm);
}

@media only screen and (max-width: 679px) {
  .content-panel {
    width: 100%;
    border-radius: 0;
  }
}
</style>
